import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { IconButton } from "@similarweb/ui-components";
import I18n from "pro-features/components/WithTranslation/src/I18n";

export const { carbon } = colorsPalettes;

export const EmptyStateIcon = styled(SWReactIcons)`
    width: 216px;
    height: 144px;
    text-align: center;
    margin-top: 10px;
`;

const GenericTitle = styled(I18n).attrs({ component: CenteredFlexRow })`
    width: 100%;
`;
export const Title = styled(GenericTitle)`
    ${setFontVariant("subsectionTitle", carbon[500])};
    margin-top: 16px;
`;
export const SubTitle = styled(GenericTitle)`
    ${setFontVariant("caption", carbon[300])};
`;
export const PageWrapper = styled.div`
    height: calc(100vh - 240px);
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const NotAvailableWrapper = styled(CenteredFlexRow)`
    flex-wrap: wrap;
`;
export const AutoCreateButton = styled(IconButton)`
    margin-top: 16px;
`;
